<template>
  <div style="min-width: 575px;">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === "" && Object.keys(tabela).length >= 1'>
      <div class="contratosConfigSig">
        <RF-Button
          :data-time='time'

          :cpntStatus='""' 
          :cpntId='tabela.id + "-novo"' 
          :cpntTexto='"Novo Signatário"' 
          :cpntClass='[ "btn", "btn-info", "btn-sm" ]'

          @onClickButton='contratosConfigSigAdicionar'
        ></RF-Button>

        <RF-Tabela class="contratosConfigSig-tabela" :data-time='time'
          :cpntTime='time'
          :cpntId='tabela.id'
          :cpntStatus='tabela.status'
          :cpntButtonImprimir='tabela.acoes.btImprimir'
          :cpntButtonAtualizar='tabela.acoes.btAtualizar'
          :cpntFraseTop='tabela.fraseTop'
          :cpntColuna='tabela.coluna'
          :cpntLinha='tabela.linha'
          :cpntCountAll='tabela.countAll'
          :cpntColspan='tabela.colspan'
          :cpntButtonsAcoes='tabela.acoes.buttons'
          :cpntMper='tabela.mper'
          :cpntPagina='tabela.pagina'
          :cpntCheckboxEditar='tabela.checkboxEditar'
          :cpntMostrar='tabela.mostrar'

          :cpntOnCheckboxAtualiza='contratosConfigSigOnCheckboxAtualiza'
          :cpntOnRefreshTabela="contratosConfigSigTabelaIniciar"
          :ref='tabela.id'
        ></RF-Tabela>
      </div>
    </template>

    <RF-Dialog v-if="formAddNovo === true" class="contrato-form-dialog"
      :cpntStatus='""'
      :cpntLargura='"800px"'
      :cpntTitulo='"Adicionar um novo Signatário"'

      :cpntOnFecharDialog='contratosConfigSigAdicionar'>
      <template slot="conteudo">
        <div id='contratosConfigSig-busca' :style='"width: " + ((formulario.hasOwnProperty("status") && formulario.status === "" && formulario.field.contato.valueRef !== "") ? "685px" : "385px")'>
          <table>
            <tr>
              <td style="vertical-align: top;">
                <RF-Formulario :data-time='time' :style='"display: inline-block; width: " + ((formulario.hasOwnProperty("status") && formulario.status === "" && formulario.field.contato.valueRef !== "") ? "645px" : "312px")'
                  :cpntTime='time'
                  :cpntId='formulario.id' 
                  :cpntStatus='formulario.status'
                  :cpntField='formulario.field'
                  :cpntUltAlt='formulario.ult_alt'
                  :cpntButtons='formulario.buttons'

                  :ref='formulario.id'
                ></RF-Formulario>
              </td>
            </tr>
          </table>
        </div>
      </template>
    </RF-Dialog>
  </div>
</template>

<style scoped>
  .contratosConfigSig-tabela {
    margin: 15px 15px 15px 0px;
  }

  #contratosConfigSig-busca {
    margin: 0px auto;
    /* text-align: center; */
    margin-top: 10px;
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    /* margin-bottom: 10px; */
    display: block;

    background: #efefef;
    border: 1px solid #c6c4c4;
    border-radius: 5px;
  }
</style>

<style>
  .contratosConfigSig-tabela > table > tbody > tr > td {
    padding: 8px 10px !important;
  }

  #contratosConfigSig-busca > table > tr > td > div > .rf-buttons-form {
    margin-bottom: 20px;
    width: 645px;
    max-width: 645px;
  }
    #contratosConfigSig-busca > table > tr > td > div > .rf-form {
      margin-bottom: 0px;
    }
      #contratosConfigSig-busca > table > tr > td > div > .rf-form > div.rf-input-group > input {
        border: 1px solid #CCC;
      }

      #contratosConfigSig-busca > table > tr > td > div > .rf-form .dropdown-menu {
        position: fixed;
      }
</style>

<script>
  export default {
    components: {
      'RF-Input-Complite': () => import('@/components/rf-geral/input-complite/RF-Input-Complite.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        formulario: {},
        tabela: {},
        checkbox: {},
        buscaContato: {},
        acaoSignatarios: [
          { id: '1', nome: 'Assinar' },
          { id: '2', nome: 'Aprovar' },
          { id: '3', nome: 'Reconhecer' },
          { id: '4', nome: 'Assinar como parte' },
          { id: '5', nome: 'Assinar como testemunha' },
          { id: '6', nome: 'Assinar como interveniente' },
          { id: '7', nome: 'Acusar recebimento' },
          { id: '8', nome: 'Assinar como Emissor, Endossante e Avalista' }
        ],
        formAddNovo: false
      }
    },
    mounted: function () {
      this.contratosConfigSigIniciar()
    },
    methods: {
      contratosConfigSigIniciar: function () {
        // SETA O STATUS GERAL
        this.statusGeral = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA INICIAR O FORMULARIO
        this.contratosConfigSigFormularioIniciar()
      },
      contratosConfigSigFormularioIniciar: function () {
        var self = this

        // SETA O STATUS GERAL
        self.statusGeral = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.formulario = {
          status: 'carregando',
          id: 'Contratos-Config-Sign-Form',
          field: {}
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // SETA OS DADOS DO AUTOCOMPLITE DE BUSCA
        self.formulario.field.contato = {
          tamanho: 52,
          tipo: 'auto-complite',
          status: '',
          nome: 'Contato (DIGITE e SELECIONE)',
          router: '/contato/get',
          method: 'POST',
          field: { id: null, nome: null, empresa: null, cnpj_cpf: null, pessoa: null, status: null, email_ctr: null },
          where: { aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'contato', o: 's.ft', v: '' } ] },
          keyMostra: [ 'nome', ' | ', 'empresa', ' | ', 'cnpj_cpf' ],
          addButForm: {
            id: 'contratos-config-sig-bt-new-value-con',
            status: '',
            texto: 'Adicionar novo contato',
            class: [ 'btn', 'btn-primary', 'btn-sm' ],
            onClickButton: function (string) {
              // SETA OS PARAMETROS QUE SERÁ ENVIADO
              var params = { editar: true, tipo: 'contato', id: 0, nome: string }

              // SETA O CALLBACK QUE DEVE EXECUTAR
              params.callback = (atualizar, id, dados) => {
                if (atualizar === true) {
                  // CHAMA A FUNÇÃO ON CHANGE
                  self.formulario.field.contato.onChange(dados, self.formulario.field.contato.id)

                  // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                  self.time = new Date().getTime()
                }
              }

              // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
              self.$store.commit('SET_ABRIR_CADASTRO_VET', params)
            }
          },
          apiEnv: 'id_con',
          onChange: function (value) {
            if (value.hasOwnProperty('id')) {
              // SETA O VALOR RECEBIDO
              self.formulario.field.contato.valueRef = value.id
              self.formulario.field.contato.value = value.nome
              self.formulario.field.contato.options = value

              // HABILITA OS CAMPOS NOVAMENTE
              self.formulario.field.acao.mostrar = true

              self.formulario.buttons.env.mostrar = true
              self.formulario.buttons.can.mostrar = true

              // SETA O CAMPO QUE RECEBE O FOCUS
              self.$store.state.FUN_FOCUS_CAMPO_IN_FORM(self, 'formulario', 'acao', false)
            }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          },
          onRealizaBusca: function (busca) {
            // OCULTA OS BOTÕES DO FORMULARIO
            self.formulario.buttons.env.mostrar = false
            self.formulario.buttons.can.mostrar = false

            self.formulario.field.acao.mostrar = false

            // SETA O VALOR RECEBIDO
            self.formulario.field.contato.valueRef = ''
            self.formulario.field.contato.value = busca

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          },
          onKeyPressEnter: function () {
            // SETA O CAMPO QUE RECEBE O FOCUS
            self.$store.state.FUN_FOCUS_CAMPO_IN_FORM(self, 'formulario', 'acao', false)
          }
        }
        self.formulario.field.acao = {
          tipo: 'select2',
          tamanho: 2,
          nome: 'Ação da assinatura',
          options: self.acaoSignatarios,
          mostrar: false,
          apiEnv: 'id_acao',
          onChange: function (value) {
            // SETA O VALOR RECEBIDO
            self.formulario.field.acao.value = value

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }
        }

        self.$store.state.FUN_CREATE_KEY_FIELDS(self.formulario.field, function (fields) {
          // SETA OS CAMPOS RECEBIDOS
          self.formulario.field = fields

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          self.$store.state.FUN_CREATE_BUTTON_FORM(self.formulario.id, [ 0 ], null, {
            env: self.contratosConfigSigFormularioInserir,
            can: function () {
              // OCULTA OS BOTÕES DO FORMULARIO
              self.formulario.buttons.env.mostrar = false
              self.formulario.buttons.can.mostrar = false

              self.formulario.field.acao.mostrar = false

              // SETA O VALOR RECEBIDO
              self.formulario.field.contato.valueRef = ''
              self.formulario.field.contato.value = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }
          }, function (buttons) {
            // CRIA OS BUTTONS DO FORMULARIO
            self.formulario.buttons = buttons

            // OCULTA OS BUTTONS QUANDO ESTA INICIANDO
            self.formulario.buttons.can.mostrar = false
            self.formulario.buttons.env.mostrar = false

            // SETA O STATUS PARA O FORMULARIO
            self.formulario.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // // SETA O CAMPO QUE RECEBE O FOCUS
            // self.$store.state.FUN_FOCUS_CAMPO_IN_FORM(self, 'formulario', 'contato', false)

            // CHAMA A FUNÇÃO PARA INICIAR A TABELA
            self.contratosConfigSigTabelaIniciar()
          })
        })
      },
      contratosConfigSigFormularioInserir: function () {
        var self = this

        if (self.formulario.field.acao.value !== '') {
          // COLOCA O STATUS DE CARREGANDO PARA O BUTTON
          self.formulario.buttons.env.status = 'carregando'

          // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
          self.time = new Date().getTime()

          self.$store.state.FUN_CREATE_FORM_API_FORMULARIO(self.formulario.field, {}, function (formData) {
            self.$store.state.comunicaAPI('/contrato/config/pre-signatario', 'POST', formData, function (apiSuccess) {
              // CHAMA A FUNÇÃO PARA MOSTAR A MENSAGEM RECEBIDA DA API
              self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
                self.contratosConfigSigIniciar()

                // CHAMA A FUNÇÃO PARA FECHAR O FORMULARIO
                self.contratosConfigSigAdicionar()
              })
            }, function (apiError) {
              self.contratosConfigSigSetaErroAPi(apiError)
            }, function (apiValid, apiStatus) {
              self.$store.state.FUN_API_RET_VALIDA(self, 'formulario', apiValid, apiStatus, self.formulario.field, true, function (form) {
                // SETA OS CAMPOS COM OS ERROS
                self.formulario.field = form

                // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
                self.formulario.buttons.env.status = ''

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()
              })
            })
          })
        } else {
          self.$store.state.msgWarn('WEB [406]: Para inserir o signatário é necessário selecionar a ação da assinatura que será realizada por ele.', 'warning')
        }
      },
      contratosConfigSigAdicionar: function () {
        // SETA O FLAG PARA ABRIR O FORMULARIO
        this.formAddNovo = !this.formAddNovo

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA O CAMPO QUE RECEBE O FOCUS
        if (this.formAddNovo === true) {
          this.$store.state.FUN_FOCUS_CAMPO_IN_FORM(this, 'formulario', 'contato', false)
        }
      },
      contratosConfigSigTabelaIniciar: function () {
        var self = this

        // SETA O STATUS GERAL
        self.statusGeral = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.tabela = {
          status: 'carregando',
          id: 'contratos-config-sig',
          api: {
            router: '/contrato/config/pre-signatario/get/',
            where: { f: 'status', o: '=', v: '1' }
          },
          acoes: {
            buttons: [
              { tipo: 'editar', class: 'btn btn-warning btn-sm', tabIndex: 17006003, tipoEditar: { 'individual': null }, onClick: self.contratosConfigSiEditarRegistro },
              { tipo: 'excluir', class: 'btn btn-danger btn-sm', onClick: self.contratosConfigSigDeleteRegistro }
              // { tipo: 'adicionar', text: 'Adicionar Signatário', class: 'btn btn-default btn-sm', onClick: self.contratosConfigSigAdicionar }
            ],
            fields: {},
            tabIndex: 17006002
          }
        }

        // INFORMA TODAS AS COLUNAS DA TABELA
        self.tabela.colunaAll = [
          { mPer: 3, tipo: 'RF-Checkbox', chave: 'id', fieldApi: { id: null, id_con: { j: { nome: null, empresa: null, pessoa: null, status: null, email_ctr: null } }, id_acao: null } },
          { mPer: 3, chave: 'id_con', nome: 'Contato', tipo: 'link-contato', click: false, converte: { id: 'id_con', nome: 'id_con_nome', empresa: 'id_con_empresa', pessoa: 'id_con_pessoa', status: 'id_con_status' }, mostrarButton: true },
          { mPer: 3, chave: 'id_con_email_ctr', nome: 'E-mail para contrato', converte: { tipo: 'email', target: '_blank' } },
          { mPer: 3, chave: 'rf-acao', nome: 'Ação da assinatura' }
        ]

        self.tabela.acoes.fields = {
          id_con: [
            {
              tipo: 'select2',
              tamanho: 2,
              nome: '',
              keyMostra: [ 'nome' ],
              keyValue: 'id',
              apiEnv: 'id_con',
              optionInicialNome: '',
              apiRec: 'id_con',
              mostrar: false
            }
          ],
          'rf-acao': [
            {
              tipo: 'select2',
              tamanho: 2,
              nome: '',
              apiEnv: 'id_acao',
              optionInicialNome: '',
              apiRec: 'id_acao',
              options: self.acaoSignatarios,
              onChange: self.contratosConfigSigOnChangeValue
            }
          ]
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
        self.$store.state.FUN_TABELA_CRIAR_DADOS(self.tabela, function (tabelaSuccess) {
          // SETA OS DADOS RECEBIDOS PARA TABELA
          self.tabela = tabelaSuccess

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // SETA OS DADOS NOVOS NA TABELA
          for (var key in self.tabela.linha) {
            // SETA OS DADOS DO REGISTROS PARA CONTATO
            self.tabela.linha[key]['rf-edicao-id_con'][0].value = self.tabela.linha[key].id_con
            self.tabela.linha[key]['rf-edicao-id_con'][0].valueIni = self.tabela.linha[key].id_con

            // SETA OS DADOS DO REGISTROS PARA AÇÃO
            self.tabela.linha[key]['rf-acao'] = self.tabela.linha[key].id_acao + ' - ' + self.acaoSignatarios.filter(item => item.id === self.tabela.linha[key].id_acao)[0].nome
            self.tabela.linha[key]['rf-edicao-rf-acao'][0].value = self.tabela.linha[key].id_acao
            self.tabela.linha[key]['rf-edicao-rf-acao'][0].valueIni = self.tabela.linha[key].id_acao
          }

          // CHAMA A FUNÇÃO PARA FINALIZAR O FORMULARIO
          self.contratosConfigSigFinalizarForm()
        }, function (tabelaError) {
          // SETA OS DADOS RECEBIDOS PARA TABELA
          self.tabela.status = tabelaError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        })
      },
      contratosConfigSigCriarCampoBase: function (callback = null) {
        var self = this

        // ADICIONA A FUNÇÃO ONCHANGE PARA TODOS OS CAMPOS
        var campos = JSON.parse(JSON.stringify(self.tabela.camposBase))
        for (var key in campos) {
          if (typeof campos[key] === 'object') {
            campos[key][0].onChange = self.contratosConfigSigOnChangeValue
          }
        }

        // ADICIONA OS CAMPOS NA TABELA
        self.tabela.linha.push(campos)

        // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
        self.$store.state.FUN_TABELA_CRIAR_DADOS(self.tabela, function (tabelaSuccess) {
          // SETA OS DADOS RECEBIDOS PARA TABELA
          self.tabela = tabelaSuccess

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          if (callback !== null) {
            callback()
          }
        }, function (tabelaError) {
          // SETA OS DADOS RECEBIDOS PARA TABELA
          self.tabela.status = tabelaError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        })
      },
      contratosConfigSigFinalizarForm: function () {
        // SETA O STATUS PARA O FORMULARIO
        this.tabela.status = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      contratosConfigSigSalvaApi: function (formDataTab, info = { total: formDataTab.length, erro: 0 }) {
        var self = this

        if (formDataTab.length >= 1) {
          self.$store.state.comunicaAPI('/contrato/config/pre-signatario', 'PUT', formDataTab[0], function () {
            // REMOVE A CHAVE QUE DEU CERTO
            formDataTab.splice(0, 1)

            // CHAMA A FUNÇÃO PARA COMUNICAR OS ENVIOS
            self.contratosConfigSigSalvaApi(formDataTab, info)
          }, function (apiError) {
            // SETA O STATUS PARA O FORMULARIO
            self.tabela.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // REMOVE A CHAVE QUE DEU ERRO
            formDataTab.splice(0, 1)

            // ADICIONA UM ERRO RECEBIDO
            info.erro = info.erro + 1

            // CHAMA A FUNÇÃO PARA COMUNICAR OS ENVIOS
            self.contratosConfigSigSalvaApi(formDataTab, info)
          }, function (apiValid, apiStatus) {
            self.$store.state.FUN_API_RET_VALIDA_TABELA(apiValid, apiStatus, [], true, function () {
              // REMOVE A CHAVE QUE DEU ERRO
              formDataTab.splice(0, 1)

              // ADICIONA UM ERRO RECEBIDO
              info.erro = info.erro + 1

              // CHAMA A FUNÇÃO PARA COMUNICAR OS ENVIOS
              self.contratosConfigSigSalvaApi(formDataTab, info)
            })
          })
        } else {
          // APRESENTA A MENSAGEM RETORNADA DA API
          if (info.erro === 0 && info.total >= 1) {
            self.$store.state.msgWarn('WEB [200]: Pré-signatário(s) inserido(s) com sucesso.', 'success')
          }

          self.contratosConfigSigIniciar()
        }
      },
      contratosConfigSigOnChangeValue: function (value, id) {
        var self = this

        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')

        // SETA O VALOR RECEBIDO
        self.tabela.linha[index[1]][index[2]][index[3]].value = value

        // REMOVE A MENSAGEM DE ERRO
        self.tabela.linha[index[1]][index[2]][index[3]].mensagem = ''
        self.tabela.linha[index[1]][index[2]][index[3]].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // switch (index[2]) {
        //   // case 'contato':
        //   //   if (value !== null && value !== '' && self.tabela.camposBase.contato[0].options.filter(item => item.id === value).length === 0) {
        //   //     self.formularioExtra = {
        //   //       id: '0',
        //   //       nome: value,
        //   //       tpCon: '',
        //   //       onFecharFormulario: function (atualiza, id) {
        //   //         switch (atualiza) {
        //   //           case true:
        //   //             // CRIA A QUERY GET QUE SERÁ REALIZADO NA API
        //   //             var queryGet = { type: 'list', field: { id: null, nome: null, email_ctr: null }, return: 'dataAll', where: { aAnd: [ { f: 'id', o: 'notIn', v: '1,2' }, { f: 'status', o: '=', v: '1' } ] } }

        //   //             self.$store.state.comunicaAPI('/contato/get', 'POST', queryGet, function (apiSuccess) {
        //   //               // SETA OS CONTATOS RECEBIDOS
        //   //               self.tabela.camposBase.contato[0].options = apiSuccess.data

        //   //               // SETA OS NOVOS OPTIONS EM TODOS OS SELECTS
        //   //               for (var key in self.tabela.linha) {
        //   //                 self.tabela.linha[key].contato[0].options = apiSuccess.data
        //   //               }

        //   //               // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        //   //               self.time = new Date().getTime()

        //   //               // SETA O VALOR RECEBIDO
        //   //               setTimeout(function () {
        //   //                 // SETA O NOVO VALOR NO CAMPO
        //   //                 self.tabela.linha[index[1]][index[2]][index[3]].value = id

        //   //                 // SETA O EMAIL DE CONTRATO
        //   //                 self.tabela.linha[index[1]].email_ctr = self.tabela.camposBase.contato[0].options.filter(item => item.id === id)[0].email_ctr

        //   //                 // FECHA O FORMULARIO EXTRA
        //   //                 self.formularioExtra = {}

        //   //                 // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        //   //                 self.time = new Date().getTime()
        //   //               }, 500)
        //   //             }, function (apiError) {
        //   //               self.contratosConfigSigSetaErroAPi(apiError)
        //   //             })
        //   //             break

        //   //           case false:
        //   //             // FECHA O FORMULARIO EXTRA
        //   //             self.formularioExtra = {}

        //   //             // SETA O NOVO VALOR NO CAMPO
        //   //             self.tabela.linha[index[1]][index[2]][index[3]].value = ''

        //   //             // SETA O EMAIL DE CONTRATO
        //   //             self.tabela.linha[index[1]].email_ctr = ''

        //   //             // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        //   //             self.time = new Date().getTime()
        //   //             break
        //   //         }
        //   //       }
        //   //     }
        //   //   } else {
        //   //     // SETA O EMAIL DE CONTRATO
        //   //     self.tabela.linha[index[1]].email_ctr = self.tabela.camposBase.contato[0].options.filter(item => item.id === value)[0].email_ctr

        //   //     // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        //   //     self.time = new Date().getTime()
        //   //   }
        //   //   break
        // }
      },
      contratosConfigSigSetaErroAPi: function (apiError) {
        // SETA O STATUS PARA O FORMULARIO
        this.statusGeral = apiError

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      contratosConfigSigDeleteRegistro: function () {
        if (window.confirm('Deseja realmente excluir o(s) Signatário(s) selecionado(s)?')) {
          var self = this

          // SETA O STATUS DE CARREGANDO PARA O BOTÃO
          self.tabela.acoes.buttons[1].status = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // CRIA O FORMUARIO QUE SERÁ ENVIADO PARA API
          // var formData = { j_id: JSON.stringify(self.checkbox.id) }
          var formData = { j_id: self.checkbox.id }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          self.$store.state.comunicaAPI('/contrato/config/pre-signatario', 'DELETE', formData, function (apiSuccess) {
            self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
              // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA ATUALIZAR
              self.contratosConfigSigIniciar()
            }, 'WEB [200]: Registros excluídos com sucesso.')
          }, function (apiError) {
            self.contratosConfigSigSetaErroAPi(apiError)
          })
        }
      },
      contratosConfigSiEditarRegistro: function () {
        var self = this

        self.$store.state.FUN_CREATE_FORM_API_TABELA(self.tabela.linha, self.checkbox.id, {}, function (formDataTab) {
          self.contratosConfigSigSalvaApi(formDataTab)
        }, 'id', true, false, [ 'id', 'id' ], false)
      },
      contratosConfigSigOnCheckboxAtualiza: function (coluna = null, checkbox = null) {
        if (coluna !== null && checkbox !== null) {
          var self = this

          // PEGA O ID DA COLUNA
          var indexColuna = self.tabela.coluna.findIndex(item => item.chave === coluna)

          // SETA O VALOR RECEBIDO NO CHECKBOX
          self.checkbox[coluna] = checkbox.filter(item => item !== self.tabela.coluna[indexColuna].chave)
        }
      }
    }
  }
</script>
